export default __webpack_public_path__ + "static/media/nodejs.dd47e26e.svg";